import emailjs from "@emailjs/browser";
import { useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";

export const Contact = () => {
  const formInitialDetails = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  };

  const [status, setStatus] = useState({});
  const [formDetails, setFormDetails] = useState(
    formInitialDetails
  );
  const [buttonText, setButtonText] = useState("Send");

  const form = useRef();

  const onFormUpdate = (category, value) => {
    setFormDetails((prevDetails) => ({
      ...prevDetails,
      [category]: value,
    }));
  };

  const sendEmail = (e) => {
    e.preventDefault();

    setButtonText("Sending...");
    setStatus({});

    emailjs
      .sendForm(
        "service_u9yy5zp",
        "template_46gxejj",
        form.current,
        "G-63IKYoDHKVQ8yDE"
      )
      .then(
        () => {
          setStatus({
            success: true,
            message: "Message sent successfully.",
          });

          setFormDetails(formInitialDetails);
          setButtonText("Send");

          setTimeout(() => {
            setStatus({});
          }, 5000);
        },
        () => {
          setStatus({
            success: false,
            message:
              "Something went wrong. Please try again later.",
          });

          setButtonText("Send");

          setTimeout(() => {
            setStatus({});
          }, 5000);
        }
      );
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <img
              src={contactImg}
              alt="Contact Harsh Agria"
            />
          </Col>

          <Col md={6}>
            <h2>Let's Get In Touch</h2>

            <form ref={form} onSubmit={sendEmail}>
              <Row>
                <Col sm={6} className="px-1">
                  <input
                    type="text"
                    name="name"
                    value={formDetails.firstName}
                    required
                    placeholder="First Name"
                    onChange={(e) =>
                      onFormUpdate(
                        "firstName",
                        e.target.value
                      )
                    }
                  />
                </Col>

                <Col sm={6} className="px-1">
                  <input
                    type="text"
                    name="lname"
                    value={formDetails.lastName}
                    required
                    placeholder="Last Name"
                    onChange={(e) =>
                      onFormUpdate(
                        "lastName",
                        e.target.value
                      )
                    }
                  />
                </Col>

                <Col sm={6} className="px-1">
                  <input
                    type="email"
                    name="email"
                    value={formDetails.email}
                    required
                    placeholder="Email Address"
                    onChange={(e) =>
                      onFormUpdate(
                        "email",
                        e.target.value
                      )
                    }
                  />
                </Col>

                <Col sm={6} className="px-1">
                  <input
                    type="tel"
                    name="phno"
                    value={formDetails.phone}
                    placeholder="Phone no."
                    onChange={(e) =>
                      onFormUpdate(
                        "phone",
                        e.target.value
                      )
                    }
                  />
                </Col>

                <Col>
                  <textarea
                    rows="6"
                    name="message"
                    value={formDetails.message}
                    required
                    placeholder="Message"
                    onChange={(e) =>
                      onFormUpdate(
                        "message",
                        e.target.value
                      )
                    }
                  />

                  <button type="submit">
                    <span>{buttonText}</span>
                  </button>
                </Col>

                {status.message && (
                  <Col>
                    <p
                      className={
                        status.success === false
                          ? "danger"
                          : "success"
                      }
                    >
                      {status.message}
                    </p>
                  </Col>
                )}
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
